module.exports = __webpack_public_path__ + "static/media/good_teacher_arrows.f32c205d.svg";